export default "__VITE_ASSET__BhA7dsan__"